import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  handleRegions(event) {
    var val = event.currentTarget.value;

    if (
      val == "US" ||
      val == "United States" ||
      val == "United States of America" ||
      val == "USA"
    ) {
      $("#band_gig_state_sp").css({ visibility: "visible" });
      $("#band_gig_state").prop("disabled", false);
    } else {
      $("#band_gig_state_sp").css({ visibility: "hidden" });
      $("#band_gig_state").prop("disabled", true);
    }

    // <% unless @another %>
    // $(function(){ cswitch($('#band_gig_country').val()) });
    // <% end %>
    // $('#new_band_gig')[0].reset();
  }
}
